// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { createFetchHttpClient } from "./fetchHttpClient.js";
/**
 * Create the correct HttpClient for the current environment.
 */
export function createDefaultHttpClient() {
    return createFetchHttpClient();
}
//# sourceMappingURL=defaultHttpClient-browser.mjs.map